import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import TableCell from "../Components/TableCell";

import { useTheme } from "@mui/material/styles";

import { getTableData } from "../Service/tableData";

const TablePage = () => {
  const [data, setData] = useState([]);
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);

  const theme = useTheme();

  useEffect(() => {
    getTableData()
      .then((data) => {
        setData(data);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (data !== undefined && data !== null) {
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  const columns = useMemo(
    //column definitions...
    () => [
      {
        id: "info", //id used to define `group` column
        header: "Info",
        columns: [
          {
            accessorKey: "ticker", //accessorFn used to join multiple data into a single cell
            id: "ticker", //id is still required when using accessorFn instead of accessorKey
            header: "Ticker",
            size: 250,
            Cell: ({ renderedCellValue, row }) => {
              return (<TableCell id={row.id} ticker={row.getValue('ticker')} />);

            },
          },
          {
            accessorKey: "company", //accessorKey used to define `data` column. `id` gets set to accessorKey automatically
            header: "Company",
            size: 300,
          },
        ],
      },
      {
        id: "general",
        header: "General Data",
        columns: [
          {
            accessorFn: (row) => row?.data[0]?.open,
            header: "Open",
            filterFn: 'lessThan',
            size: 200,
          },
          {
            accessorFn: (row) => row?.data[0]?.close, //hey a simple column for once
            header: "Close",
            size: 250,
          },
          {
            accessorFn: (row) => row?.data[0]?.high, //hey a simple column for once
            header: "High",
            size: 250,
          },
          {
            accessorFn: (row) => row?.data[0]?.low, //hey a simple column for once
            header: "Low",
            size: 250,
          },
          {
            accessorFn: (row) => row?.data[0]?.volume, //hey a simple column for once
            header: "Volume",
            size: 250,
          },
        ],
      },
      {
        id: "ema", //id used to define `group` column
        header: "Moving Average Data",
        columns: [
          {
            accessorFn: (row) => {
              if (row == undefined || row == null || row.data[0] == undefined || row.data[0] == null) {
                return "";
              }
              if (row?.data[0].ema20 !== null && row?.data[0].ema20 !== undefined) {
                return `${row?.data[0].ema20.toFixed(3)}`;
              }
              else {
                return "";
              }
            }, //accessorFn used to join multiple data into a single cell
            id: "ema20", //id is still required when using accessorFn instead of accessorKey
            header: "ema20",
            size: 250,
          },
          {
            accessorFn: (row) => {
              if (row == undefined || row == null || row.data[0] == undefined || row.data[0] == null) {
                return "";
              }
              if (row?.data[0].ema50 !== null && row?.data[0].ema50 !== undefined) {
                return `${row?.data[0].ema50.toFixed(3)}`;
              }
              else {
                return "";
              }
            },
            id: "ema50", //id is still required when using accessorFn instead of accessorKey
            header: "ema50",
            size: 250,
          },
          {
            accessorFn: (row) => {
              if (row == undefined || row == null || row.data[0] == undefined || row.data[0] == null) {
                return "";
              }
              if (row?.data[0].ema100 !== null && row?.data[0].ema100 !== undefined) {
                return `${row.data[0].ema100.toFixed(3)}`;
              }
              else {
                return "";
              }
            },
            id: "ema100", //id is still required when using accessorFn instead of accessorKey
            header: "ema100",
            size: 250,
          },
          {
            accessorFn: (row) => {
              if (row == undefined || row == null || row.data[0] == undefined || row.data[0] == null) {
                return "";
              }
              if (row?.data[0].ema200 !== null && row?.data[0].ema200 !== undefined) {
                return `${row?.data[0].ema200.toFixed(3)}`;
              }
              else {
                return "";
              }
            },
            id: "ema200", //id is still required when using accessorFn instead of accessorKey
            header: "ema200",
            size: 250,
          },
        ],
      },
      {
        id: "oscillators",
        header: "oscillators",
        columns: [
          {
            accessorFn: (row) => row?.data[0]?.rsi?.toFixed(3),
            header: "rsi",
            size: 200,
          },
          {
            accessorFn: (row) => row?.data[0]?.macd?.macd, //hey a simple column for once
            header: "macd",
            size: 250,
          },
          {
            accessorFn: (row) => row?.data[0]?.macd?.signal, //hey a simple column for once
            header: "macd signal",
            size: 250,
          },
          {
            accessorFn: (row) => row?.data[0]?.macd?.divergence, //hey a simple column for once
            header: "macd divergence",
            size: 250,
          }
        ],
      }
    ],
    []
    //end
  );
  const table = useMaterialReactTable({
    columns,
    data,
    // enableFilters: false,
    enableFullScreenToggle: false,
    enableStickyHeader: true,
    enableColumnPinning: true,
    initialState: { 
      density: 'compact',
      columnPinning: { left: ['ticker', 'company'] },
    }
  });

  return (
    <div style={{ width: "100%", minWidth: '100vw', minHeight: '100vh', background: `${theme.palette.background.default}` }}>
      {loading && <CircularProgress />}
      {noData && <Typography>No data was received</Typography>}
      {data !== null &&
          data !== undefined && <MaterialReactTable table={table}/>}
    </div>
  );
};

export default TablePage;
